<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="injected-chart" :class="type === 'views-list' && 'fixed-height-chart'">
    <div v-if="title" class="chart-title">
      {{ dataCard.data[0].title }}
    </div>
    <div v-if="type === 'views-list'" class="prof-noti">
      <NotifPro
        :fav-id="favId"
        :payload="config.payload"
        :enabled-state="config.enabled"
        @reload-data="reloadData"
      />
    </div>
    <SDVChart
      v-if="hasBeenMounted && contentData && dataCard && dataCard.code !== 500 && chartId !== 'map'"
      ref="chart"
      :class="type"
      :data="tableData"
      :chart-type="chartId"
      :chart-config="chartConfig"
      :pivot-config="pivotConfig"
      :tooltip-function="tooltipFunction"
      :dimension-metas="dimensionMetas"
      :data-card="dataCard"
      :options="flatDimensionsOptions"
      :all-time-values="allTimeValues"
      :lite="true"
    />
    <template v-else-if="hasBeenMounted && contentData && dataCard && dataCard.code !== 500 && chartId === 'map'">
      <div class="map-title" :class="{padded: type==='views-list'}">{{ config.title }}   </div>
      <Map
        ref="chart"
        :data="tableData"
        :map-config="chartConfig"
        :pivot-config="pivotConfig"
        :tooltip-function="tooltipFunction"
        :dimension-metas="dimensionMetas"
        :data-card="dataCard"
        :options="flatDimensionsOptions"
        :all-time-values="allTimeValues"
        :lite="true"
      />
    </template>

    <div v-else class="loading">
      <div class="loading-title" :class="{padded: type==='views-list'}">{{ config.title }}   </div>
      <div v-if="dataCard" class="loader">{{ $t('data_error') }}</div>
      <div v-else class="loader"> {{ $t('loading') }} </div>
    </div>
    <div v-if="dataCard" class="bottom">
      <div class="bottom-item source" v-html="$t('add_font') + ': ' + trunkedFont" /><div class="separator" />
      <div class="bottom-item date"><div class="calendar-icon" />{{ formattedDate }}</div><div class="separator" />
      <a :href="parsedUrl" :target="blank ? '_blank' : ''">
        <div class="bottom-item link">{{ $t('see_id') }}</div>
      </a>
    </div>
  </div>
</template>

<script>
import SDVChart from './SDVChart.vue'
import Map from '../maps/Map.vue'
import NotifPro from '../profile/NotifPro.vue'
import { getStatisticsTable } from '@/services/table-api'
import { getItemById } from '@/services/api'
import { buildPivotTable, getAllTimeValues } from '@/utils/dataUtils'
import { stringToFilters, applyDiffs } from '@/utils/filterUtils'
import { createDefaultPivotConfig, flattenDimensions } from '@/utils/dimensionUtils.js'
import dayjs from 'dayjs'
import { sdvTooltipFunction } from '@/utils/chart'
import { getCardKpis } from '@/utils/kpiUtils'
import { t } from '@/i18n'
// import { maskValue } from '@/utils/formatUtils'

export default {
  components: { SDVChart, NotifPro, Map },
  props: {
    config: Object,
    visible: Boolean,
    type: {
      type: String,
      default: 'normal',
    },
    favId: {
      type: Number,
    },
    title: {
      type: Boolean,
    },
		blank: {
			type: Boolean,
			default: false
		}
  },
  data() {
    return {
      hasBeenMounted: false,
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false,
        minZoom: 11.5,
        attributionControl: false,
        scrollWheelZoom: false,
      },
      loading: true,
    }
  },
  computed: {
    trunkedFont() {
      // me lo cargo y provamos con css  line-clmap
      if (this.dataCard && this.dataCard.data && this.dataCard.data[0].docSource) {
        let parsedSource = this.dataCard.data[0].docSource.map(el => {
          let regex = /(<([^>]+)>)/gi
          return el.replace(regex, '')
        })
        parsedSource = parsedSource.join(', ')
        return parsedSource
      }
      return ''
      // if (this.dataCard && this.dataCard.data && this.dataCard.data[0].docSource) {
      //   let parsedSource = this.dataCard.data[0].docSource.map(el => {
      //     let regex = /(<([^>]+)>)/ig
      //     return el.replace(regex, "")
      //   })
      //   parsedSource = parsedSource.join(', ')
      //   return parsedSource.length <= 40
      //     ? parsedSource
      //     : parsedSource.slice(0, 37) + '...'
      // }
      // return ''
    },
    formattedDate() {
      return (
        this.dataCard &&
        this.dataCard.data &&
        dayjs(this.dataCard.data[0].publishDate).format('MM/YYYY')
      )
    },
    parsedUrl() {
      let configSplitted = this.config.url.split('/')
      let source = { ca: "estadístiques", es: "estadísticas", en: "statistics" }
      return '/' + this.$route.params.lang + '/' + source[this.$route.params.lang] + '/' + configSplitted[(configSplitted.length - 1)]
    },
    injectedRoute() {
      return this.$router.resolve({ path: this.config.url }).resolved
    },
    cardId() {
      return this.injectedRoute.params.cardId ? this.injectedRoute.params.cardId : this.injectedRoute.params.params
    },
    currentLang() {
      // con universl ids podemos poner el lang de verdad!
      return this.$store.state.i18n.lang //this.injectedRoute.params.lang
    },
    chartId() {
      return this.injectedRoute.query.chart || this.injectedRoute.query.view
    },
    // sdvComponent() {
    //   return chartUtils[this.chartId].sdvComponent
    // },
    dimensions() {
      return this.contentData?.dimensions
    },
    pivotConfig() {
      if (!this.dimensions) return
      let q = this.injectedRoute.query
      let defaultPivotConfig = createDefaultPivotConfig(this.dimensions, {
        id: this.chartId,
        enabled: true,
      })
      // console.log('route', route)
      let config = applyDiffs(defaultPivotConfig, stringToFilters(q.diff),this.dimensions)
      // this.internalPivotConfig = { ...this.internalPivotConfig, ...config }
      return config
    },
    chartConfig() {
      let q = this.injectedRoute.query
      let injectedChartConfig = stringToFilters(q.ccfg)
      // injectedChartConfig = injectedChartConfig.reduce((cfg, c) => {
      //   cfg = { ...cfg, ...c }
      //   return cfg
      // }, {})
      let subTitle = getCardKpis(this.config, this.tableData)
        .map(
          kpi =>
            `<div class="kpi"><span class="label">${t(kpi.id)}</span>: <span class="value">${
              kpi.value
            }</span></div>`
        )
        .join(' ')
      return {
        ...injectedChartConfig.config,
        title: this.config.title,
        subTitle: subTitle,
      }
    },
    dimensionOptions() {
      return this.contentData?.dimensions && this.contentData.dimensions.dimensionOptions
    },
    flatDimensionsOptions() {
      return (
        this.contentData.dimensions &&
        flattenDimensions(this.contentData.dimensions).dimensionOptions
      )
    },
    dimensionMetas() {
      return this.contentData?.dimensions && this.contentData.dimensions.dimensionMetas
    },
    allTimeValues() {
      return getAllTimeValues(
        this.contentData?.data,
        this.pivotConfig,
        this.flatDimensionsOptions,
        this.dimensionMetas
      )
    },
    tableData() {
      let data =
        this.contentData?.data && this.pivotConfig && this.flatDimensionsOptions
          ? buildPivotTable(
              this.contentData.data,
              this.pivotConfig,
              this.flatDimensionsOptions,
              this.dimensionMetas,
              this.dataCard?.data[0]?.unit
            )
          : null
      return data ? data : null
    },
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) this.hasBeenMounted = true
      },
      immediate: true,
    },
  },
  methods: {
    reloadData() {
      this.$emit('reload')
    },
    tooltipFunction(d, key, self) {
      return sdvTooltipFunction(
        d,
        key,
        self,
        this.dataCard,
        this.pivotConfig,
        this.dimensionMetas,
        this.dimensionOptions,
        this.flatDimensionsOptions
      )
    },
  },
  asyncComputed: {
    locationFilter() {
      if (!this.internalPivotConfig) return null
      let locFil = this.internalPivotConfig.dimensions.find(el => {
        return el.role === 'types' && el.id.slice(0, el.id.length - 5) === this.locationDim
      })
      let finded = locFil.values.find(el => el.value === 'districte' || el.value === 'Districte')
      if (finded) locFil.values = [finded]
      return locFil
    },

    dataCard() {
      // this.dataCard = null
      return (
        this.hasBeenMounted &&
        getItemById(this.cardId, this.currentLang, 'statistic').then(resp => {
          return resp
        })
      )
    },
    contentData() {
      if (this.hasBeenMounted && this.dataCard?.values) {
        return getStatisticsTable(this.dataCard)
      } else return null
    },
  },
}
</script>

<style lang="stylus" scoped>
.injected-chart
  position: relative
  display: flex
  flex-direction: column
  padding: vw(20px)
  border-radius: 8px
  background-color: #fff
  width 100%

  &.fixed-height-chart
    height: vw(380px)
    
  .chart-title
    m-font-size(20, 24)
    font-weight: 600
    margin-bottom: vw(10px)

  .map-title,
  .loading-title
    m-font-size(18px, , true)
    display: -webkit-box
    overflow: hidden
    margin-bottom: vw(5px)
    font-weight: bold
    font-family: "SourceSansPro"
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical

    &.padded
      padding-right: vw(100px)

  .prof-noti
    position: absolute
    top: vw(10px)
    right: vw(6px)
    z-index: 2

  .map
    flex: 1 1 0

  .views-list
    >>> .el
      .title
        margin-bottom: vw(4px)
        // width: 80%
        padding-right: vw(100px)

  .sdv-chart
    >>> .el
      .legend-container
        .legend-item
          .label
            m-font-size(14, , true)

      .wrapper
        margin: 0 !important
        width: 100% !important
        height: 100% !important
        gap: vw(10px)

      .legend-container
        &:empty
          display: none

      .axis
        .title
          m-font-size(14, , true)

        .tick
          m-font-size(13, , true)

      .title
        m-font-size(18, 26, true)

      .sub-title
        m-font-size(15, , true)
        display: flex !important

        .kpi
          margin-right: vw(5px)

          .label
            font-weight: bold

  .bottom
    m-font-size(12, 16)
    display: flex
    align-items: center

    .separator
      margin: 0 vw(10px)
      width: 1px
      height: vw(20px)
      background: $bcn-other-grey

    .bottom-item
      display: flex

      &.source
        display: -webkit-box
        flex: 1 1 0%
        overflow: hidden
        // max-width: vw(350px)
        -webkit-line-clamp: 1
        -webkit-box-orient: vertical

      &.link
        color: $corporate_color
        cursor: pointer

        &:hover
          color: $corporate_color
          text-decoration: underline

      .calendar-icon
        m-icon("calendar", 16)
        margin-right: vw(4px)

  .loading
    width: 100%
    height: 100%
    background: #fff

    .loader
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
</style>
